if (!customElements.get('tabbed-image')) {
  customElements.define(
    'tabbed-image',
    class TabbedImage extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();

        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));
        if (this.tabs.length === 0) return;

        this.abort = new AbortController();
        const { signal } = this.abort;

        this.addEventListener('click', this.onClick, { signal });
        this.addEventListener('keydown', this.onKeydown, { signal });

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', this.onBlockSelect, { signal });
        }
      }

      disconnectedCallback() {
        this.abort?.abort();
      }

      onClick = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (tab && this.contains(tab)) this.select(tab.dataset.index);
      };

      onKeydown = (event) => {
        const tab = event.target.closest('[role="tab"]');
        if (!tab || !this.contains(tab)) return;

        const current = this.tabs.indexOf(tab);
        if (current < 0) return;

        let next = current;
        if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
        else return;

        event.preventDefault();
        this.select(this.tabs[next].dataset.index);
        this.tabs[next].focus();
      };

      onBlockSelect = (event) => {
        if (event.target.dataset.index != null) this.select(event.target.dataset.index);
      };

      select(index) {
        const id = String(index);

        this.tabs.forEach((tab) => {
          const selected = tab.dataset.index === id;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          tab.classList.toggle('button--primary', selected);
          tab.classList.toggle('button--secondary', !selected);
        });

        this.panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.index === id);
        });
      }
    }
  );
}
